var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.5H4C4.27614 18.5 4.5 18.7239 4.5 19V26C4.5 26.2761 4.27614 26.5 4 26.5H1C0.723858 26.5 0.5 26.2761 0.5 26V19C0.5 18.7239 0.723858 18.5 1 18.5Z",
    stroke: "#442B8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5H13C13.2761 12.5 13.5 12.7239 13.5 13V26C13.5 26.2761 13.2761 26.5 13 26.5H10C9.72386 26.5 9.5 26.2761 9.5 26V13C9.5 12.7239 9.72386 12.5 10 12.5Z",
    stroke: "#7B63BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.5H22C22.2761 6.5 22.5 6.72386 22.5 7V26C22.5 26.2761 22.2761 26.5 22 26.5H19C18.7239 26.5 18.5 26.2761 18.5 26V7C18.5 6.72386 18.7239 6.5 19 6.5Z",
    stroke: "#7B63BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.5H31C31.2761 0.5 31.5 0.723858 31.5 1V26C31.5 26.2761 31.2761 26.5 31 26.5H28C27.7239 26.5 27.5 26.2761 27.5 26V0.999999C27.5 0.723857 27.7239 0.5 28 0.5Z",
    fill: "#5DC9DD",
    stroke: "#5DC9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.69c92985993c5eee2313f39a20fe93c4.svg";
export { ForwardRef as ReactComponent };